export default "/public/img/logoLeftDe-c6a6fa2b38e8a559039b42d8b5d46866.png";